import {DumpsterFire} from "../DumpsterFire";
import {DFGameConfig} from "../DFGameConfig";
import {TimelineLite, gsap} from "gsap";
import {DumpsterFireModel} from "../server/DumpsterFireModel";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";

export class FireAnim extends PIXI.Container {
    private _matrix: any = []
    private allSpine: PIXI.spine.Spine[] = [];

    constructor() {
        super();
        this.init();
    }

// Function to add a spine to the matrix
    public addFireAnimToMatrix(reelId: number, rowId: number, animName: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(this.removeFireSpineFromMatrix(reelId, rowId), 0)
        if (reelId >= 0 && reelId < 6 && rowId >= 0 && rowId < 5) {
            const spineAnim: PIXI.spine.Spine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("multiplier_highlight"));
            tl.add([() => {
                spineAnim.visible = true;
                this.addChild(spineAnim);
                this._matrix[reelId][rowId] = spineAnim;
                this.allSpine.push(spineAnim);
            }]);
            spineAnim.x = reelId * DFGameConfig.symbolWidth + 60;
            spineAnim.y = rowId * DFGameConfig.symbolHeight + 130;
            tl.add(() => {
                spineAnim.state.setAnimation(0, animName, true);
            });
        } else {
            console.log('Invalid position');
        }
        return tl;
    }

    public init() {
        for (let reelId: number = 0; reelId < 6; reelId++) {
            this._matrix[reelId] = [];
            for (let col: number = 0; col < 5; col++) {
                let sprite: PIXI.Sprite = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("")[0]);
                sprite.visible = false;
                sprite.x = col * 118;
                sprite.y = reelId * 118;

                // Push spine into the matrix at position [row][col]
                this._matrix[reelId].push(sprite);
                // this._matrix[row][col].push(spine);
                this.addChild(sprite);
            }
        }
    }

    public removeFireSpineFromMatrix(reelId: number, rowId: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            const spine: PIXI.Sprite = this._matrix[reelId][rowId];
            this.removeChild(spine);
            this._matrix[reelId][rowId] = null;
        }, 0);
        return tl;
    }

    public removeAllSpines(): void {
        for (let reelId: number = 0; reelId < 6; reelId++) {
            for (let rowId: number = 0; rowId < 5; rowId++) {
                const spine: PIXI.spine.Spine = this._matrix[reelId][rowId];
                this.removeChild(spine);
                this._matrix[reelId][rowId] = null;
            }
        }
        this.allSpine.forEach((item) => {
            this.removeChild(item);
        });
        DumpsterFire.soundPlayer.stopSound(DumpsterFireSound.MULTI_FIRE);
    }
}